import { render, staticRenderFns } from "./SideInfo.vue?vue&type=template&id=6339f031&"
import script from "./SideInfo.vue?vue&type=script&lang=js&"
export * from "./SideInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports